const e=e=>{if("undefined"==typeof document)return;const o=document.cookie.match(new RegExp(`(?:^|; )${e.replace(/([.$?*|{}()[\]\\/+^])/g,"\\$1")}=([^;]*)`));return o?decodeURIComponent(o[1]):void 0};export{e as getCookie};
//# sourceMappingURL=index.js.map
